import { StyledInvalidMessage } from './styled';

export const InvalidMessage = StyledInvalidMessage;
